import React from 'react';
import "./content-box.css";
import { ReactComponent as IconSvg } from "./icon.svg";
import Modal from '../../modal';

class ContentBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false
        };
    }

    openModal = () => {
        this.setState({ isModalOpen: true });
    };

    closeModal = () => {
        this.setState({ isModalOpen: false });
    };

    render() {
        const contentBoxContent = (
            <div className="content-box">
                <div className="icon-container">
                    <IconSvg className="content-box-icon" />
                </div>
                <p className="content-box-text">{this.props.text}</p>
            </div>
        );

        // If link prop is provided, render as anchor tag
        if (this.props.link) {
            return (
                <a 
                    href={this.props.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="content-box-wrapper content-box-clickable content-box-link"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {contentBoxContent}
                </a>
            );
        }

        // Otherwise, render as clickable div for modal or non-interactive
        return (
            <>
                <div 
                    className={`content-box-wrapper ${this.props.modalContent ? 'content-box-clickable' : ''}`}
                    onClick={this.props.modalContent ? this.openModal : undefined}
                >
                    {contentBoxContent}
                </div>
                
                {this.props.modalContent && (
                    <Modal 
                        isOpen={this.state.isModalOpen} 
                        onClose={this.closeModal}
                    >
                        {this.props.modalContent}
                    </Modal>
                )}
            </>
        );
    }
}

export default ContentBox;